import { useState } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";

import { formatPlain, isNumberText, parseNumberText } from "../../utilities/format";

type NumberTextFieldProps = Omit<TextFieldProps, "value" | "onChange" | "type"> & {
  value: number | null | undefined;
  onChange: (value: number | null) => void;
};

export default function NumberTextField({ value, onChange, slotProps, ...props }: NumberTextFieldProps) {
  const [text, setText] = useState(() => formatPlain(value) ?? "");
  const shown = parseNumberText(text) === (value ?? null) ? text : formatPlain(value) ?? "";

  return (
    <TextField
      {...props}
      value={shown}
      slotProps={{ ...slotProps, htmlInput: { inputMode: "decimal", ...slotProps?.htmlInput } }}
      onChange={event => {
        if (!isNumberText(event.target.value)) return;
        setText(event.target.value);
        onChange(parseNumberText(event.target.value));
      }}
    />
  );
}
